import { emberClient } from '@ember/api-client'
import { useMemo } from 'react'
import { getContextToken } from './auth'

/**
 * Hook to get the API client with the current context token automatically injected.
 */
export function useApiClient() {
  const token = getContextToken()

  return useMemo(() => {
    if (!token) return emberClient
    return emberClient.withContextToken(token)
  }, [token])
}
